// 2026-10 — 結帳時「浮在畫面上的東西」讓位。
//
// 問題(手機走查 T1014-34):
//   1) Cookie 提示框(ConsentBanner,fixed bottom-0 z-90)蓋住貼紙頁底部「已選 N 張 / 結帳」條,
//      第一次來的客人(海外新客 100% 是)選完圖看不到結帳鈕。
//   2) 右下 IG 浮動鈕(FloatingIG)蓋到結帳表單裡的金額、門市按鈕、地址框。
// 做法:不讓三個元件互相 import,改用 <html> 上的兩個訊號,再由 globals.css 決定誰讓位:
//   - CSS 變數 --checkout-bar-h:底部結帳條目前的高度 → Cookie 框往上推這麼多
//   - 屬性 data-checkout-open:結帳表單開著 → IG 浮動鈕與 Cookie 框先藏起來
import { useEffect } from "react";

export const CHECKOUT_OPEN_ATTR = "data-checkout-open";
export const CHECKOUT_BAR_VAR = "--checkout-bar-h";

/**
 * 結帳表單開著時在 <html> 標上 data-checkout-open。
 * 用計數而不是 true/false:貼紙表單與購物車理論上可能同時掛著,
 * 一邊關掉不能把另一邊的標記拿掉。
 */
export function markCheckoutOpen(root) {
  const n = Number(root.getAttribute(CHECKOUT_OPEN_ATTR) || 0) + 1;
  root.setAttribute(CHECKOUT_OPEN_ATTR, String(n));
  return () => {
    const left = Number(root.getAttribute(CHECKOUT_OPEN_ATTR) || 1) - 1;
    if (left > 0) root.setAttribute(CHECKOUT_OPEN_ATTR, String(left));
    else root.removeAttribute(CHECKOUT_OPEN_ATTR);
  };
}

export function useCheckoutOpen(open) {
  useEffect(() => {
    if (!open) return undefined;
    return markCheckoutOpen(document.documentElement);
  }, [open]);
}

/** 底部結帳條顯示時,把它的高度寫進 --checkout-bar-h;消失就清掉(Cookie 框回到最底)。 */
export function useBottomBarOffset(ref, active) {
  useEffect(() => {
    const el = ref.current;
    if (!active || !el) return undefined;
    const root = document.documentElement;
    const apply = () =>
      root.style.setProperty(
        CHECKOUT_BAR_VAR,
        `${Math.ceil(el.getBoundingClientRect().height)}px`,
      );
    apply();
    const ro =
      typeof ResizeObserver !== "undefined" ? new ResizeObserver(apply) : null;
    ro?.observe(el);
    return () => {
      ro?.disconnect();
      root.style.removeProperty(CHECKOUT_BAR_VAR);
    };
  }, [ref, active]);
}
